import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Button } from 'components/patterns'
import { TextArea } from 'components/deprecated/Inputs'

export const DrawerContentWrapper = styled.div`
  margin: -20px;
  height: calc(100% + 32px);
  width: calc(100% + 40px);
  display: flex;
  padding: 16px;
  flex-direction: column;
`

export const FlexHeaderWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 16px;
`

export const DrawerTitle = styled.h3`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`

export const AddNewCommentSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  margin-bottom: 16px;
`

export const StyledTextArea = styled(TextArea)`
  width: 100%;
`

export const SaveCommentBtn = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const CommentsSection = styled.div`
  border-top: 1px solid ${themeColor('grey')};
  padding: 16px;
  margin: 0 -16px;
  flex: 1;
  display: flex;
  height: calc(100% - 125px);
  flex-direction: column;
  background-color: ${themeColor('modalGrey')};
`

export const CommentsSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TotalCommentsCountText = styled.h4`
  font-size: 14px;
  font-weight: bold;
  margin: 0;
`
export const SortButton = styled(Button)`
  margin: 0 !important;
  height: 14px !important;
  padding: 8px !important;
  display: flex;
  gap: 10px;
  font-size: 14px !important;
  height: 30px !important;
  line-height: 15px !important;
  &:hover {
    color: ${themeColor('blackSecondary')} !important;
  }
`
export const CommentsList = styled.ul`
  padding: 0;
  margin: 0;
  margin-top: 16px;
  list-style: none;
  overflow: auto;
  flex: 1;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track:vertical {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:vertical {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }
`
export const CommentsListItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0;
  border-bottom: thin solid ${themeColor('grey')};
  &:first-child {
    padding-top: 0;
  }
`
export const CommentHeader = styled.div`
  display: flex;
  justify-content: space-between;
`
export const CommentTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`
export const CommentTitle = styled.h6`
  font-size: 12px;
  font-weight: bold;
  color: ${themeColor('blackSecondary')};
  margin: 0;
`
export const CommentPostedTimeString = styled.span`
  font-size: 12px;
  color: ${themeColor('blackSecondary')};
`
export const CommentString = styled.div`
  font-size: 14px;
  color: ${themeColor('blackSecondary')};
`
